import { Col, Form, Row, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import MainCard from '../../../components/MainCard';
import { useDispatch } from 'react-redux';
import { createGlobalMenu } from '../../../store/slices/globalMenu/globalMenuThunk';

export function GlobalMenuForm() {
  const dipatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: '',
      description: ''
    }
  });

  const onSubmit = (data) => {
    dipatch(createGlobalMenu(data));
  };

  return (
    <MainCard
      title="Create a Global Menu"
      subheader="After completing this setup, you will have access to create categories, locations, and food items."
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          {/* Menu Name */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Menu Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter menu name"
                {...register('name', {
                  required: 'Menu name is required'
                })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">{errors.name?.message}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          {/* Description */}
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} placeholder="Enter menu description" {...register('description')} />
            </Form.Group>
          </Col>
        </Row>

        {/* Submit Button */}
        <div className="text-end">
          <Button variant="dark" type="submit">
            Save Global Menu
          </Button>
        </div>
      </Form>
    </MainCard>
  );
}
